import { multiLanguage } from "../../hoc";
import React, { Component } from "react";
import { withRouter } from "react-router-dom"; // Route,
import _ from "lodash";
import PT from "prop-types";
import { Parallax } from "react-skrollr";
import { Slider, Modal, BackgroundImage } from "../../components";
import { TypeResidences } from "../../containers";

import { parseQueryString } from "../../utils";

@multiLanguage()
class Residences extends Component {
  static propTypes = {
    t: PT.func,
    match: PT.shape().isRequired,
  };
  static defaultProps = {
    t: () => {},
  };
  state = {
    showTypeModal: false,
    currentSection: 0,
    showTourModal: false,
    hoverType: null,
  };
  createTypeBtn = () => {
    const { type, t } = this.props;
    const { hoverType } = this.state;
    return _.map(type, (item, key) => {
      console.log(".... createTypeBtn", item);
      return (
        <div
          key={key}
          className={`residence-divbtn ${hoverType === key ? "active" : ""}`}
          onClick={(e) => this.handleClickType(key, e)}
          onMouseEnter={() =>
            this.setState({
              hoverType: key,
            })
          }
          onMouseLeave={() =>
            this.setState({
              hoverType: null,
            })
          }
        >
          <div className="image-block">
            <BackgroundImage
              className="residence-imagetype img-0"
              image={item.thumbnail[0].image}
            />
            <BackgroundImage
              className="residence-imagetype img-1"
              image={item.thumbnail[1].image}
            />
          </div>

          <div className="residence-text">{t(_.get(item, "name"))}</div>
        </div>
      );
    });
  };
  handleClickType = (key, e) => {
    e.preventDefault();
    this.setState({
      showTypeModal: true,
      currentSection: key,
    });
  };
  handleCloseTypeModal = () => {
    this.setState({ showTypeModal: false });
    // clear queryString
    const { history, location } = this.props;
    history.push(`${location.pathname}`);
  };
  render() {
    const { landingPage, type, t } = this.props;
    if (_.isEmpty(type)) return null;
    const { hoverType } = this.state;
    const { currentSection, showTypeModal } = this.state;
    const locationParams = _.get(this.props, "location.search");
    const searchParams = new URLSearchParams(locationParams);
    const currentSectionSearchParams = searchParams.get("currentSection");
    const idCurrentSection = currentSectionSearchParams
      ? currentSectionSearchParams
      : currentSection;
    const dataModel = _.filter(
      type,
      (item, key) => key === Number(idCurrentSection)
    );
    console.log("dataModel", dataModel);
    // const widthScreen = window.innerWidth;
    // const lgSize = 960;
    // console.log("landingPage", landingPage);
    // console.log('this.props.match >>> residence >>> ', this.props);
    // const currentFromUrl2 = parseQueryString() // queryString.parse(_.get(this.props.location, "search"));
    // const currentFromUrl = queryString.parse(_.get(this.props.location, "search"));
    const currentFromUrl = parseQueryString(); // queryString.parse(_.get(this.props.location, "search"));
    // console.log('currentFromUrl.currentSection >>> ', currentFromUrl.currentSection);
    // console.log('showTypeModal >>> ', showTypeModal);
    return (
      <div className="section-residence">
        <div className="parallax-container">
          <Parallax
            data={{
              "data-bottom-top":
                "transform: translateY(-100px); filter: blur(200px) saturate(2);",
              "data-150-top":
                "transform: translateY(0px); filter: blur(0px) saturate(1);",
            }}
          >
            <div className="image-slider-block">
              <Slider
                items={landingPage}
                settings={{ arrows: false }}
                uiRenderer={(item, index) => {
                  return (
                    <BackgroundImage
                      key={index}
                      className="residence-imagetype img-2"
                      image={_.get(item, "image")}
                      position={_.get(
                        item,
                        "backgroundPosition",
                        "center center"
                      )}
                    />
                  );
                }}
              />
            </div>
          </Parallax>
        </div>
        {_.map(type, (value, key) => {
          return (
            <BackgroundImage
              key={key}
              className={`image-hover-show type-${key} ${
                hoverType === key ? "show" : ""
              }`}
              image={_.get(value, "thumbnail.1.image")}
            />
          );
        })}
        <div className="residence-alpha">
          <div className="parallax-container">
            <Parallax
              data={{
                "data-bottom-top": "transform: translateY(100px); opacity: 0;",
                "data-bottom-bottom": "transform: translateY(0px); opacity: 1;",
              }}
            >
              <div className="bg" />
            </Parallax>
          </div>
        </div>
        <div className="residence-containertype-btn">
          <Parallax
            data={{
              "data-bottom-top": "transform: translateY(100px);",
              "data-bottom-bottom": "transform: translateY(0px);",
            }}
          >
            <div className="residence-typebtn btn">{this.createTypeBtn()}</div>
          </Parallax>
        </div>
        {/* <Route
          exact
          key="phuket-laguna-park-2"
          // path="/:language/projects/phuket/laguna-park-2/:currentSection"
          path={`${this.props.match.url}/:currentSection`}
          children={(txt) => {
            console.log('text >>> ', txt);
            console.log('children >> ', _.get(txt.location, "pathname"));
            console.log('this.props.match >> ', this.props.match);
            return (_.get(txt.location, "hash") === '#residence') &&
              (
                <Modal name="residences-modal" onCancel={this.handleCloseTypeModal}>
                  <TypeResidences data={dataModel} t={t} currentSection={0} />
                </Modal>
              )
            }
          }
        /> */}
        {(showTypeModal || currentFromUrl.currentSection !== undefined) && (
          <Modal name="residences-modal" onCancel={this.handleCloseTypeModal}>
            <TypeResidences data={dataModel} t={t} currentSection={0} />
          </Modal>
        )}
      </div>
    );
  }
}

export default withRouter(Residences);



// WEBPACK FOOTER //
// ./src/pages/common/Residences.js